export default __webpack_public_path__ + "static/media/megafono.923838c5.png";